import React from "react";
import { Check, AlertTriangle, X, HelpCircle, ShieldCheck, ShieldAlert, ShieldX, Shield } from "lucide-react";

const CONFIG = {
    // CLAIM mode
    true: { label: "TRUE", color: "text-emerald-400", ring: "ring-emerald-500/60", bg: "bg-emerald-500/15", glow: "badge-glow-green", Icon: Check, dot: "bg-emerald-500", tone: "green" },
    mostly_true: { label: "MOSTLY TRUE", color: "text-emerald-300", ring: "ring-emerald-400/40", bg: "bg-emerald-500/10", glow: "badge-glow-green", Icon: Check, dot: "bg-emerald-500", tone: "green" },
    misleading: { label: "MISLEADING", color: "text-amber-400", ring: "ring-amber-500/60", bg: "bg-amber-500/15", glow: "badge-glow-yellow", Icon: AlertTriangle, dot: "bg-amber-500", tone: "yellow" },
    false: { label: "FALSE", color: "text-red-400", ring: "ring-red-500/60", bg: "bg-red-500/15", glow: "badge-glow-red", Icon: X, dot: "bg-red-500", tone: "red" },
    unverified: { label: "UNVERIFIED", color: "text-muted-foreground", ring: "ring-white/20", bg: "bg-white/5", glow: "", Icon: HelpCircle, dot: "bg-slate-400", tone: "gray" },
    // SCAM mode
    safe: { label: "SAFE", color: "text-emerald-400", ring: "ring-emerald-500/60", bg: "bg-emerald-500/15", glow: "badge-glow-green", Icon: ShieldCheck, dot: "bg-emerald-500", tone: "green" },
    likely_safe: { label: "LIKELY SAFE", color: "text-emerald-300", ring: "ring-emerald-400/40", bg: "bg-emerald-500/10", glow: "badge-glow-green", Icon: Shield, dot: "bg-emerald-500", tone: "green" },
    suspicious: { label: "SUSPICIOUS", color: "text-amber-400", ring: "ring-amber-500/60", bg: "bg-amber-500/15", glow: "badge-glow-yellow", Icon: ShieldAlert, dot: "bg-amber-500", tone: "yellow" },
    scam: { label: "SCAM", color: "text-red-400", ring: "ring-red-500/60", bg: "bg-red-500/15", glow: "badge-glow-red", Icon: ShieldX, dot: "bg-red-500", tone: "red" },
};

export function VerdictBadge({ verdict, confidence, size = "md" }) {
    const cfg = CONFIG[verdict] || CONFIG.unverified;
    const { Icon } = cfg;
    const sizes = {
        sm: "text-xs px-2.5 py-1",
        md: "text-sm px-3 py-1.5",
        lg: "text-base px-4 py-2",
    };
    return (
        <span
            data-testid={`verdict-badge-${verdict}`}
            className={`inline-flex items-center gap-2 rounded-full ring-1 font-display font-bold tracking-wide ${cfg.bg} ${cfg.ring} ${cfg.color} ${sizes[size]} ${cfg.glow}`}
        >
            <Icon className="h-3.5 w-3.5" strokeWidth={3} />
            {cfg.label}
            {typeof confidence === "number" && (
                <span className="text-[10px] opacity-70 font-semibold">{confidence}%</span>
            )}
        </span>
    );
}

export function TrafficLight({ verdict, size = 10 }) {
    const cfg = CONFIG[verdict] || CONFIG.unverified;
    const style = { width: size, height: size };
    const activeGreen = cfg.tone === "green";
    const activeYellow = cfg.tone === "yellow";
    const activeRed = cfg.tone === "red";
    return (
        <div className="flex flex-col gap-1.5">
            <span style={style} className={`rounded-full ${activeGreen ? "bg-emerald-500" : "bg-emerald-500/20"}`} />
            <span style={style} className={`rounded-full ${activeYellow ? "bg-amber-500" : "bg-amber-500/20"}`} />
            <span style={style} className={`rounded-full ${activeRed ? "bg-red-500" : "bg-red-500/20"}`} />
        </div>
    );
}
